module.exports = __webpack_public_path__ + "static/media/c1.70ed197f.jpg";